// extracted by mini-css-extract-plugin
export default {"container":"Home_container__i1WR5","innerContainer":"Home_innerContainer__qPwAU","type":"Home_type__O3Fbf","buttonSection":"Home_buttonSection__5I9h9"};